import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { IDataGenericText } from '@app/interfaces/idata-grouped';

@Component({
  selector: 'filter-tag-radio-multi',
  templateUrl: './filter-tag-radio-multi.component.html',
  styleUrls: ['./filter-tag-radio-multi.component.css']
})
export class FilterTagRadioMultiComponent {

  @Input() control: AbstractControl;
  @Input() title: string = '';
  @Input() label: string = '';
  @Input() defaultValue = null;
  @Input() dataSelect: Array<IDataGenericText> = [];

  constructor() {

  }

  onClickResetControl(event: MouseEvent): void {
    event.preventDefault();
    this.control.setValue(this.defaultValue);
  }
}